<div *ngIf="adminService.isAuthenticated()" fxLayout="column" fxFill fxLayoutAlign="start stretch" class="tasks-container">
  <div fxLayout="column" fxLayoutAlign="space-between stretch" class="user-interactions-freq-card-container">
    <mat-card class="user-interactions-freq-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title>User Interactions Frequency</mat-card-title>
        <mat-button-toggle-group name="userInteractionsFrequencyPeriod" aria-label="User Interactions Frequency Period" [(value)]="userInteractionsFrequencyPeriod" (change)="userInteractionsFrequencyPeriod = $event.value; updateUserInteractionsFrequencyChart()">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="isUserInteractionsFrequencyChartLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isUserInteractionsFrequencyChartFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <div id="user-interactions-freq-chart-svg"></div>
      </mat-card-content>
      <div fxLayout="row" fxLayoutAlign="end none">
        <mat-select [(value)]="userInteractionsFrequencyType" class="user-interactions-type-select" (selectionChange)="updateUserInteractionsFrequencyChart()">
          <mat-option value="fileImport">File Import</mat-option>
          <mat-option value="externalSearch">External Search</mat-option>
          <mat-option value="manualReplacement">Manual Replacement</mat-option>
          <mat-option value="publishAsOER">Publish as OER</mat-option>
          <mat-option value="excludeImage">Exclude Image</mat-option>
          <mat-option value="saveClicked">Save Clicked</mat-option>
        </mat-select>
      </div>
    </mat-card>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between stretch" class="type-and-images-card-container">
    <mat-card class="type-freq-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title>Type Frequency</mat-card-title>
        <mat-button-toggle-group name="typeFrequencyPeriod" aria-label="Type Frequency Period" [(value)]="typeFrequencyPeriod" (change)="typeFrequencyPeriod = $event.value; updateTypeFrequencyChart();">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="isTypeFrequencyChartLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isTypeFrequencyChartFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <div id="type-freq-chart-svg"></div>
      </mat-card-content>
      <div fxLayout="row" fxLayoutAlign="end none">
        <mat-select [(value)]="typeFrequencyType" class="type-select" (selectionChange)="updateTypeFrequencyChart()">
          <mat-option value="fileType">File Types</mat-option>
          <mat-option value="imageType">Image Types</mat-option>
          <mat-option value="targetLicenseType">Target Licenses</mat-option>
        </mat-select>
      </div>
    </mat-card>
    <mat-card class="images-processed-freq-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title>Images Processed Frequency</mat-card-title>
        <mat-button-toggle-group name="imagesProcessedFrequencyPeriod" aria-label="Images Processed Frequency Period" [(value)]="imagesProcessedFrequencyPeriod" (change)="imagesProcessedFrequencyPeriod = $event.value; updateImagesProcessedFrequencyChart()">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="isImagesProcessedFrequencyChartLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isImagesProcessedFrequencyChartFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <div id="images-processed-freq-chart-svg"></div>
      </mat-card-content>
    </mat-card>
  </div>
  <div fxLayout="column" fxLayoutAlign="space-between stretch" class="avg-time-spent-on-tasks-card-container">
    <mat-card class="avg-time-spent-on-tasks-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title>Avg Time spent on tasks (seconds)</mat-card-title>
        <mat-button-toggle-group name="avgTimeSpentOnTasksPeriod" aria-label="Avg Time spent on tasks Period" [(value)]="avgTimeSpentOnTasksPeriod" (change)="avgTimeSpentOnTasksPeriod = $event.value; updateAvgTimeSpentOnTasksChart()">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="isAvgTimeSpentOnTasksChartLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isAvgTimeSpentOnTasksChartFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <div id="avg-time-spent-on-tasks-chart-svg"></div>
      </mat-card-content>
      <div fxLayout="row" fxLayoutAlign="end none">
        <mat-select [(value)]="avgTimeSpentOnTasksType" class="avg-time-spent-on-tasks-type-select" (selectionChange)="updateAvgTimeSpentOnTasksChart()">
          <mat-option value="fileImport">File Import</mat-option>
          <mat-option value="externalSearch">External Search</mat-option>
          <mat-option value="manualReplacement">Manual Replacement</mat-option>
          <mat-option value="overallSession">Overall Session</mat-option>
        </mat-select>
      </div>
    </mat-card>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between stretch" class="bounce-and-external-search-time-card-container">
    <mat-card class="bounce-and-external-search-time-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title fxLayout="row" fxLayoutAlign="start ">
          <div>Bounce Rate</div>
          <div class="click-to-top" fxLayout="row" fxLayoutAlign="start center">
            <img width="20" height="20" src="assets/info.png" />
            <span>Indicates distribution of visitors that leave the tool after doing the shown actions</span>
          </div>
        </mat-card-title>
        <mat-button-toggle-group name="bounceRatePeriod" aria-label="Bounce Rate Period" [(value)]="bounceRatePeriod" (change)="bounceRatePeriod = $event.value; updateBounceRateChart();">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="isBounceRateChartLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isBounceRateChartFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <div id="bounce-rate-chart-svg"></div>
      </mat-card-content>
      <div fxLayout="row" fxLayoutAlign="end none">
        <mat-select [(value)]="bounceRateType" class="bounce-rate-select" (selectionChange)="updateBounceRateChart()">
          <mat-option value="saveAndImageListed">Save / Image List</mat-option>
          <mat-option value="saveAndStartClicked">Save / Start</mat-option>
          <mat-option value="startAndHomeLoaded">Start / Home</mat-option>
        </mat-select>
      </div>
    </mat-card>
    <mat-card class="avg-time-external-search-fetch-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title>External Search - Avg Time for fetch (seconds)</mat-card-title>
        <mat-button-toggle-group name="avgTimeExternalSearchFetchPeriod" aria-label="External Search - Avg Time for fetch Period" [(value)]="avgTimeExternalSearchFetchPeriod" (change)="avgTimeExternalSearchFetchPeriod = $event.value; updateAvgTimeExternalSearchFetchChart()">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="isAvgTimeExternalSearchFetchChartLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isAvgTimeExternalSearchFetchChartFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <div id="avg-time-external-search-fetch-chart-svg"></div>
      </mat-card-content>
    </mat-card>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between stretch" class="external-search-auto-targeted-apis-card-container">
    <mat-card class="auto-query-external-search-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title>External Search - Auto Search Query</mat-card-title>
        <mat-button-toggle-group name="autoQueryExternalSearchFrequencyPeriod" aria-label="External Search - Auto Search Query Frequency Period" [(value)]="autoQueryExternalSearchFrequencyPeriod" (change)="autoQueryExternalSearchFrequencyPeriod = $event.value; updateAutoQueryExternalSearchFrequencyChart()">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="isAutoQueryExternalSearchFrequencyChartLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isAutoQueryExternalSearchFrequencyChartFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <div id="auto-query-external-search-freq-chart-svg"></div>
      </mat-card-content>
    </mat-card>
    <mat-card class="targeted-apis-external-search-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title>Targeted Apis</mat-card-title>
        <mat-button-toggle-group name="targetedApisExternalSearchFrequencyPeriod" aria-label="External Search - Targeted Apis" [(value)]="targetedApisExternalSearchFrequencyPeriod" (change)="targetedApisExternalSearchFrequencyPeriod = $event.value; updateTargetedApisExternalSearchFrequencyChart();">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="isTargetedApisExternalSearchFrequencyChartLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isTargetedApisExternalSearchFrequencyChartFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <div id="targeted-apis-external-search-freq-chart-svg"></div>
      </mat-card-content>
    </mat-card>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between stretch" class="external-search-manual-targeted-licenses-card-container">
    <mat-card class="manual-vs-external-search-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title>External Search - External vs Manual for same image</mat-card-title>
        <mat-button-toggle-group name="manualVsExternalSearchFrequencyPeriod" aria-label="External Search - External vs Manual Frequency Period" [(value)]="manualVsExternalSearchFrequencyPeriod" (change)="manualVsExternalSearchFrequencyPeriod = $event.value; updateManualVsExternalSearchFrequencyChart()">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="isManualVsExternalSearchFrequencyChartLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isManualVsExternalSearchFrequencyChartFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <div id="manual-vs-external-search-freq-chart-svg"></div>
      </mat-card-content>
    </mat-card>
    <mat-card class="targeted-licenses-external-search-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title>Targeted Licenses</mat-card-title>
        <mat-button-toggle-group name="targetedLicensesExternalSearchFrequencyPeriod" aria-label="External Search - Targeted Licenses" [(value)]="targetedLicensesExternalSearchFrequencyPeriod" (change)="targetedLicensesExternalSearchFrequencyPeriod = $event.value; updateTargetedLicensesExternalSearchFrequencyChart();">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="isTargetedLicensesExternalSearchFrequencyChartLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isTargetedLicensesExternalSearchFrequencyChartFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <div id="targeted-licenses-external-search-freq-chart-svg"></div>
      </mat-card-content>
    </mat-card>
  </div>
  <div fxLayout="column" fxLayoutAlign="space-between stretch" class="task-model-card-container">
    <mat-card class="task-model-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title fxLayout="row" fxLayoutAlign="start ">
          <div>Task Model</div>
          <div class="click-to-top" fxLayout="row" fxLayoutAlign="start center">
            <img width="20" height="20" src="assets/info.png" />
            <span>Indicates flow of tasks for an user from the chosen session id</span>
          </div>
        </mat-card-title>
        <mat-form-field appearance="fill" class="task-model-select-form">
          <mat-label>Session ID</mat-label>
          <mat-select [(value)]="taskModelSessionId" class="task-model-select" (selectionChange)="updateTaskModel()">
            <mat-option *ngFor="let sessionId of taskModelSessionIds" [value]="sessionId">
              {{sessionId}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-card-header>
      <mat-card-content fxLayout="row" fxLayoutAlign="space-between start">
        <div *ngIf="isTaskModelLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isTaskModelFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <!-- *ngIf="!isTaskModelLoading && !isTaskModelFailed" -->
        <div class="svg-zoom-buttons">
          <button id="svg-zoom-in">+</button>
          <button id="svg-zoom-out">-</button>
        </div>
        <svg class="task-model-svg" id="task-model-svg">
          <g></g>
        </svg>
        
        <div class="task-model-legend" fxLayout="row" fxLayoutAlign="center center">
          <div>
            <div class="legend-item" fxLayout="row" fxLayoutAlign=" center">
              <div class="legend-start-circle"></div>
              <div>Start</div>
            </div>
            <div class="legend-item" fxLayout="row" fxLayoutAlign=" center">
              <div class="legend-task-flow-bar"></div>
              <div>Task Flow</div>
            </div>
            <div class="legend-item" fxLayout="row" fxLayoutAlign=" center">
              <div class="legend-missing-flow-bar"></div>
              <div>Missing Flow</div>
            </div>
            <div class="legend-item" fxLayout="row" fxLayoutAlign=" center">
              <div class="legend-optional-flow-bar"></div>
              <div>Optional Flow</div>
            </div>
            <div class="legend-item" fxLayout="row" fxLayoutAlign=" center">
              <div class="legend-negative-flow-bar"></div>
              <div>Negative Flow</div>
            </div>
            <div class="legend-item" fxLayout="row" fxLayoutAlign=" center">
              <div class="legend-end-circle"></div>
              <div>End</div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>